import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {IntegratedInstanceSearchModel} from "../integrated-instance-search.model";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";

@Component({
    selector: "wbo-integrated-instance-single-select-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    styleUrls: ["./integrated-instance-single-select-control.component.scss"],
    providers: [
        registerSelectEditControl(IntegratedInstanceSingleSelectControlComponent),
        provideSearchModel(IntegratedInstanceSearchModel)
    ]
})
export class IntegratedInstanceSingleSelectControlComponent extends AbstractSingleSelectEditControlComponent<IntegratedInstanceSearchModel> {
    constructor(model: IntegratedInstanceSearchModel, injector: Injector) {
        super(model, injector, "instanceUrl", "instanceName");
    }
}
